import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { config } from "../CommonUrl/CommonUrls";
import { InfoAlert, TokenAlert } from "../CommonPopupAndAlerts/SweetAlerts";
const RefreshFunction = async (url, values, method) => {
  var refreshToken = Cookies.get("jwtRefreshToken")
  var initvalues = {
    refreshToken: refreshToken
  }
  try {
    let ref_url = config.url.BOC_URL + "auth/refresh-token"
    const res = await axios.post(ref_url, initvalues);
    if (res.data.scode === "01") {
      var decoded = jwtDecode(res.data.access_token);
      var decoded_refresh = jwtDecode(res.data.refresh_token);
      var date = new Date(decoded.exp * 1000);
      var ref_date = new Date(decoded_refresh.exp * 1000);
      Cookies.set("jwtToken", res.data.access_token, { expires: date });
      Cookies.set("jwtTokenTym", res.data.access_token_expiration, { expires: date });
      Cookies.set("jwtRefreshToken", res.data.refresh_token, { expires: ref_date });
      Cookies.set("jwtRefreshTokenTym", res.data.refresh_token_expiration, { expires: ref_date });
      if (method === "get") {
        return CommonAxiosGet(url);
      }
      else if (method === "post") {
        return CommonAxiosPost(url, values);
      }
    }
  } catch (err) {
    return catchErrorMessages(err, url, values, method)
    // console.log("error at refresh token>>>>>", err)
  }
}
export const CommonAxiosGet = async (url, values) => {

  let jwtToken = Cookies.get("jwtToken");
  let refreshToken = Cookies.get("jwtRefreshToken");

  // let jwtToken = localStorage.getItem("jwtToken");
  // let refreshToken = localStorage.getItem("jwtRefreshToken");

  if (jwtToken === undefined && refreshToken !== undefined) {
    return RefreshFunction(url, values, "get")
  }
  else if (jwtToken !== undefined) {
    let data = "";
    try {
      let res = await axios({

        url: url,
        method: "get",
        headers: { Authorization: `Bearer ${jwtToken}` },
        // withCredentials: true
      });
      if (res.status === 200) {
        data = res;
      }
      return data;
    } catch (err) {
      return catchErrorMessages(err, url, values, "get")
      // console.log("error at commonget>>>>", err)
    }
  }
  else if (refreshToken === undefined) {
    TokenAlert()
  }

}
export const CommonAxiosPost = async (url, values) => {
  let data = "";
  let jwtToken = Cookies.get("jwtToken");
  let refreshToken = Cookies.get("jwtRefreshToken");

  //  let jwtToken = localStorage.getItem("jwtToken");
  // let refreshToken = localStorage.getItem("jwtRefreshToken");

  if (jwtToken === undefined && refreshToken !== undefined) {
    return await RefreshFunction(url, values, "post")
  }
  else if (jwtToken !== undefined) {
    try {
      let res = await axios({
        url: url,
        method: "post",
        data: values,
        headers: { Authorization: `Bearer ${jwtToken}` },
        // withCredentials: true
      });
      if (res.status === 200) {
        data = res;
      }
      return data;
    } catch (err) {
      return catchErrorMessages(err, url, values, "post")
      // console.log("error at commonget>>>>", err)
    }
  }
  else if (refreshToken === undefined) {
    TokenAlert()
  }
};

export const CommomLoginAunthenticatePost = async (url, values) => {

  try {
    let data = "";
    let res = await axios({
      url: url,
      method: "post",
      data: values,
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) { }
};

export const CommonAxiosPut = async (url, values) => {
  let token = Cookies.get("jwtToken");
  try {
    let data = "";
    let res = await axios({
      url: url,
      method: "put",
      data: values,
      headers: { Authorization: "Bearer " + token },
    });
    if (res.status === 200) {
      data = res;
    }
    return data;
  } catch (err) { }
};


export const catchErrorMessages = async (err, url, values, method) => {
  if (err.response.status === 401) {
    // return await RefreshFunction(url, values, method);
    TokenAlert();
  } else 
    if (err.response.status === 500) {
    InfoAlert("Internal Server Error,Try After Sometime", "warning");
  } else if (err.response.status === 404) {
    InfoAlert("Page Not Found", "warning");
  } else if (err.response.status === 504) {
    InfoAlert("Timed Out", "warning");
  } else {
    console.log("catchErrorMessages >>>>>>>>>>> ", err)
  }
}